import { concat } from "lodash";

import routerOrders from "./orders";
// import routerQuotes from "./quotes";
import routerRoutes from "./routes";
import routerInvoices from "./invoice";
// import routerSettlementCarrier from "./settlement_carrier";
// import routerSettlementCustomers from "./settlement_customers";

import Transactions from "../../../../pages/Transactions";
import routerInvoiceProvider from "./invoiceProvider";
import routerInvoiceClient from "./invoiceClient";
import routerRouteMap from "./routeMap";

const routesTransactions = [{ key: "transactions", path: "/transactions", element: <Transactions />, }]

const routes = concat(
    routesTransactions,
    routerOrders,
    // routerQuotes,
    routerRoutes,
    routerInvoices,
    // routerSettlementCarrier,
    // routerSettlementCustomers,
    routerInvoiceProvider,
    routerInvoiceClient,
    routerRouteMap
)

export default routes
